import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { OnboardingStageWorkflow } from "@/pages/settings/components/contractsSettings/types";
import OnboardingWorkflowCard from "./OnboardingWorkflowCard";

interface OnboardingWorkflowListProps {
  workflows?: OnboardingStageWorkflow[];
  currentStageId?: string;
  onAssigned?: () => void;
  emptyKey: string;
}

const OnboardingWorkflowList: React.FC<OnboardingWorkflowListProps> = ({
  workflows,
  currentStageId,
  onAssigned,
  emptyKey
}) => {
  const { t } = useTranslation();

  if (!workflows || workflows.length === 0) {
    return (
      <div className="flex items-center justify-center p-12">
        <Text variant="bodySecondary" className="text-secondary">
          {t(emptyKey)}
        </Text>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full max-h-[700px]">
      <div className="flex-1 overflow-y-auto p-6">
        <div className="flex flex-col gap-4">
          {workflows.map((workflow) => (
            <OnboardingWorkflowCard
              key={workflow.id}
              workflow={workflow}
              currentStageId={currentStageId}
              onAssigned={onAssigned}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OnboardingWorkflowList;
